import React from "react"
import ReactDOM from "react-dom"

import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react"
import { App } from "./App"
import appConfig from "./config/app.config"
import "./index.css"
import reportWebVitals from "./reportWebVitals"

const gb = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: appConfig.growthbookClientKey,
  disableCache: true,
})

gb.init({
  streaming: true,
})

ReactDOM.render(
  <React.StrictMode>
    <GrowthBookProvider growthbook={gb}>
      <App />
    </GrowthBookProvider>
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
